export function array8(n) {
  return new Uint8Array(n);
}
export function array16(n) {
  return new Uint16Array(n);
}
export function array32(n) {
  return new Uint32Array(n);
}